// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--3GMrg","emptyText":"emptyText--sm9Cn"};